export default "__VITE_ASSET__DiszcK2J__"